export default __webpack_public_path__ + "static/media/HFlologo.75945c28.png";